import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ChecklistServicesApi } from "../../service/api/ChecklistServicesApi";
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import ChecklistRow from "./ChecklistRow";

import styles from "./EditChecklist.module.css";

import EditChecklistLogic from "./EditChecklistLogic";
import Loading from "../../components/Loading/Loading";
import GenericModal from "../../UI/GenericModal";
import { useDispatch } from "react-redux";
import InfoIconWithTooltip from "../../UI/InfoIconWithTooltip/InfoIconWithTooltip";
import { getFirstMultiDigitNumber } from "../../globalFunctions/globalFunctions";
import { isSuperuserValue } from "../../access/access";

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());
let queryStringChecklistId = params["checklistId"];

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito

const EditChecklist = (props) => {
  const {
    /* state */ error, setError,
    isLoading, setIsLoading,
    isLoadingButtons, setIsLoadingButtons,
    finalData, 
    checklistId, setChecklistId,
    opScopes, setOpScopes,
    qualitativeEvaluationOnly, 
    originalData, setOriginalData,
    modalShow,
    modalAction,
    modalTitle,
    modalMessage,
    modalType,
    /* functions */ 
    initialConfiguration,
    // createDataObject,
    // createQuestionObject,
    // updateOriginalData,
    // createQuestionInOriginalForm,
    tickingElementHandler,
    untickingElementHandler,
    addQuestionHandler,
    removeQuestionHandler,
    updateQuestionHandler,
    saveChecklistHandler,
    evaluateChecklistHandler,
    modalDataHandler,
    modalCloseHandler,
    collapseElement
  } = EditChecklistLogic(); // custom hook

  const history = useHistory();
  const dispatch = useDispatch();

  console.log("render start");

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/checklist-monitor");
    }
    let mounted = true; // used to make sure that the component is still mounted before updating data in this component to avoid problems
    setIsLoading(true);

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringChecklistId = params["checklistId"];
    setChecklistId(queryStringChecklistId);
    console.log("chekclist id ", queryStringChecklistId)
    // const checklist = require("./checklist-1-data-copy.json");
    setEditChecklistIdHandler(queryStringChecklistId); // setting the checklist id so that we can redirect to edit-new-checklist when the back button is clicked
    
    const checklistServicesApi = new ChecklistServicesApi();

    checklistServicesApi.getChecklistById(queryStringChecklistId, (checklistInfoError, checklistInfo) => { 
      console.log("checklist info: ", checklistInfo);
      if (checklistInfo.checklistState.name !== "Draft") {
        console.log("Checklist with id ", checklistInfo.id, " does not have a status of Draft");
        history.push("/checklist-monitor");
      }
      if (mounted) { // making sure that the component is still mounted before updating any state
        if (!checklistInfoError) {
          props.setChecklistName(checklistInfo.name);
          
          checklistServicesApi.getChecklistCosoHierarchyById(queryStringChecklistId, (error, data) => { 
            const fattoriQualificanti = data;
            if (mounted) { // making sure that the component is still mounted before updating any state
              if (!error) {
                setOriginalData(data);
                console.log("fattoriQualificanti ", fattoriQualificanti);
                initialConfiguration(queryStringChecklistId, fattoriQualificanti);
              } else {
                setError(() => {
                  throw new Error ("");
                  // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + checklistInfoError.message);
                })
              }
            }
          });   
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (checklistInfoError.response ? checklistInfoError.response.statusCode : "") + " " + checklistInfoError.message);
          })
        }
      }
    });

    console.log("componentDidMount");

    return () => {
      mounted = false;
    }
  }, []); //finalData.length  

  const setEditChecklistIdHandler = (checklistId) => {
    dispatch({ type: 'setEditChecklistId', checklistId})
  }

  const renderHeader = () => {
    console.log("Header rendered");
    console.log("opscopez: ",opScopes)
    return (
    <thead className={styles.tableTHead}>
        <tr>
          <th rowSpan="2" className={`${styles.fatQual} bg-transparent border-bottom-0`}></th>
          <th rowSpan="2" className={`${styles.bgGrey} ${styles.questionsWidth} text-white align-middle`}>
            Questions
          </th>
          <th colSpan={opScopes.length} className={`${styles.bgGrey} text-white align-middle`}>
            Operational Scopes
          </th>
        </tr>
        <tr>
          {finalData && opScopes.map((opScope) => (
            <th key={`${opScope.id} - ${opScopes.name}`} className={`${styles.opScopes} position-relative py-1 px-2`}
              onMouseEnter={(e) => showOpScopeInfoIcon(e, opScope.id)}
              onMouseLeave={(e) => hideOpScopeInfoIcon(e, opScope.id)}
            >
              {opScope.name}
              <InfoIconWithTooltip text={opScope.tooltip} show={opScope.infoIconIsVisible} />
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  const showOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();
    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = true;

    setOpScopes(updatedOpScopes)
  };

  const hideOpScopeInfoIcon = (e, osId) => {
    e.preventDefault();
    
    const updatedOpScopes = [...opScopes];
    updatedOpScopes.filter(os => os.id === osId)[0].infoIconIsVisible = false;

    setOpScopes(updatedOpScopes)
  };

  let principioDisplayId = 1;
  if(originalData) console.log("originalData: ", originalData); // [0].checklistCosoPrincipi[0].checklistCosoRequisiti[0].checklistCosoAmbiti[0].checklistQualitativeQuestions);
  console.log("finalData: ", finalData);
  
  let transformedData = finalData && [...finalData];

  let fatQualSpan = 0;
  for (let i = transformedData.length - 1; i >= 0; i--) {
    let el = transformedData[i];
    if (el.type && el.type === "fatQual") { // we don't count the elements that are hidden
      el.span = fatQualSpan;
      fatQualSpan = 0;
    } else {
      if (!el.isHidden)
      fatQualSpan++;
    }
  }

  let tableData = transformedData && transformedData.map((el, index) => {
   
    if (el.type === "principio") {
      principioDisplayId = getFirstMultiDigitNumber(el.title);
    }
    if (el.type && el.type === "fatQual") {
      console.log(el.span);
      return (
        <tr key={el.type + '-' + el.id}> 
          {/* style={{background: `rgb(${red+=9}, ${green+=26}, ${blue+=16})`}} */}
          <td className={styles.fatQual} rowSpan={el.span + 1}>
            <span className={styles.verticalText}>{el.title}</span>
          </td>
        </tr>
      );
    } else {
      if (!el.isHidden) {
        return (
          <ChecklistRow
            key={
              el.type
                ? el.type + "-" + el.id
                : el.questionType + "-" + index
            }
            title={el.title}
            opScopes={el.operationalScopes}
            type={el.type}
            pos={index}
            questionType={el.questionType}
            ambitoType={el.ambitoType}
            isCollapsed={el.isCollapsed}
            hasValidChildren={el.hasValidChildren}
            tooltip={el.tooltip}
            principioId={principioDisplayId}
            displayId={el.displayId}
            unchecking={untickingElementHandler}
            checking={tickingElementHandler}
            addQuestion={addQuestionHandler}
            removeQuestion={removeQuestionHandler}
            updateQuestion={updateQuestionHandler}
            modalDataHandler={modalDataHandler}
            collapseElement={collapseElement}
            qualEvaluationOnly={qualitativeEvaluationOnly}
          />
        );
      }
    }
  });

  const tableStyle = `${styles.border2px} ${styles.table} ${styles.tableHover} text-center table`;
  let table = (
    <table className={`${tableStyle} ${styles.tableRelative} mb-1`}>
      {/* {renderHeader()} */}
      <tbody>
        {tableData}
      </tbody>
    </table>
  );

  return (
    <div className={`position-relative outerContainer`}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      {isLoading && <Loading />}
      {!isLoading && (
        <table className={`${tableStyle} ${styles.sticky} mb-0`}>
          {renderHeader()}
        </table>
      )}
      {!isLoading && table}
      {!isLoadingButtons && !isLoading && (
        <div className="d-flex justify-content-center">
          <SubmitButton
            click={() =>
              modalDataHandler(
                "Save Checklist",
                "Save Questions?",
                'confirmation',
                saveChecklistHandler
              )
            }
          >
            Save
          </SubmitButton>
          <SubmitButton
            click={() =>
              modalDataHandler(
                "Confirm Checklist",
                "Save Questions and set checklist to Evaluate?",
                'confirmation',
                evaluateChecklistHandler
              )
            }
          >
            Validate
          </SubmitButton>{" "}
          {/*  */}
        </div>
      )}
      {isLoadingButtons && <Loading />}
    </div>
  );
}

export default EditChecklist;
